export const CONTACT = {
  phone: "+91 91487 21103",
  phoneLink: "+919148721103",
  email: "koreyaah@gmail.com",
  hours: "11:30 AM – 11:30 PM",
  address: "Shop No. 20, Sy.No 43/2, SH35, Natura Walk, Yamare Village, Sarjapur Hobli, Anekal, Bengaluru, Karnataka 562125",
  city: "Sarjapur, Bengaluru",
  mapsEmbed:
    "https://www.google.com/maps?q=Koreyaah+Korean+Street+Food+Natura+Walk+Yamare+Sarjapur+Bengaluru&output=embed",
  mapsDirections: "https://maps.app.goo.gl/ibXEbUSiPHrdvY3a6",
  social: {
    instagram: "https://instagram.com/koreyaah",
    facebook: "https://facebook.com/koreyaah",
    linkedin: "https://www.linkedin.com/company/koreyaah",
    google: "https://www.google.com/maps/place/Koreyaah+:+Korean+Street+Food",
  },
};

const embed = (q) => `https://www.google.com/maps?q=${encodeURIComponent(q)}&output=embed`;

export const STORES = [
  {
    name: "Koreyaah — Sarjapur",
    label: "Sarjapura",
    area: "Natura Walk, Yamare",
    status: "open",
    address:
      "Shop No. 20, Sy.No 43/2, SH35, Natura Walk, Yamare Village, Sarjapur Hobli, Anekal Taluk, Yamare, Anekal, Bengaluru, Karnataka 562125",
    directions: "https://maps.app.goo.gl/ibXEbUSiPHrdvY3a6",
    embed: embed("Koreyaah Korean Street Food Natura Walk Yamare Sarjapur Bengaluru 562125"),
  },
  {
    name: "Koreyaah — Begur",
    label: "Begur",
    area: "The Hub, Yelenahalli",
    status: "open",
    address:
      "Shop No. 04, Lower Ground, The Hub, Raj Serenity, Yelenahalli Village, Begur, B.B. Hobli, Bommanahalli, Bengaluru, Karnataka 560114",
    directions: "https://maps.app.goo.gl/bsMTLderbVM7dfwN8",
    embed: embed("Koreyaah Korean Street Food The Hub Yelenahalli Begur Bommanahalli Bengaluru 560114"),
  },
  {
    name: "Koreyaah — Prestige Tech Park",
    label: "Prestige Tech Park",
    area: "Prestige Tech Park 4",
    status: "coming",
    address:
      "Unit No. Cafe-02, Ground Floor, The Gravity, Prestige Tech Park 4, Kadubeesanahalli, Outer Ring Rd, M.P East, Prestige Tech Park, Bengaluru, Karnataka 560103",
    directions: "https://maps.app.goo.gl/A9Mc2kqwE2bpEYRq5",
    embed: embed("Prestige Tech Park 4 The Gravity Kadubeesanahalli Outer Ring Road Prestige Tech Park Bengaluru 560103"),
  },
];

export const CATEGORIES = [
  "All",
  "Ramen",
  "Noodle Box",
  "Fried Rice",
  "Tteok-bokki",
  "Bao Buns",
  "Dumplings",
  "Korean Fried Chicken",
  "Corn Dogs",
  "Karaage Fries",
  "Beverages",
  "Desserts",
];

const IMG = {
  ramen: "/menu/korean-ramen.jpg",
  noodle: "/menu/k-noodle.jpg",
  friedRice: "/menu/bukkeum-bap.jpg",
  bao: "/menu/bao-buns.jpg",
  dumpling: "/menu/dumplings.jpg",
  wings: "/menu/k-wings.jpg",
  corndog: "/menu/korn-dogs.jpg",
  fries: "/menu/k-fries.jpg",
  matcha: "/menu/matcha.jpg",
  taro: "/menu/taro.jpg",
  koko: "/menu/kokonata.jpg",
  chocoBao: "/menu/choco-bao.jpg",
};

export const KFC_FLAVOURS = ["Original", "Spicy Korean", "Gochujang", "Yangnyeom", "Snow Cheese", "Sweet Chilli", "Spicy BBQ"];

// Authentic Koreyaah menu (from brand menu sheet). Prices in ₹. Seafood variants
// were retired on 12 Mar 2025 and are omitted.
export const MENU = [
  // ---------- RAMEN ----------
  {
    name: "Buldak Raboki",
    category: "Ramen",
    desc: "Our fieriest ramen-tteokbokki mashup — buldak heat, chewy rice cakes and springy noodles in a blazing sauce.",
    img: IMG.ramen,
    spice: 5,
    variants: [{ label: "Veg", price: 299 }, { label: "Chicken", price: 349 }],
    signature: true,
    tag: "Fiery",
  },
  {
    name: "Hot & Spicy Ramen",
    category: "Ramen",
    desc: "Bold, punchy broth with a serious spice kick and soul-warming noodles.",
    img: IMG.ramen,
    spice: 4,
    variants: [{ label: "Veg", price: 299 }, { label: "Chicken", price: 329 }],
    tag: "Bestseller",
  },
  {
    name: "Black Bean Ramen",
    category: "Ramen",
    desc: "Savoury, glossy jjajang black-bean sauce over thick noodles — rich, moreish and comforting.",
    img: IMG.ramen,
    spice: 3,
    variants: [{ label: "Veg", price: 299 }, { label: "Chicken", price: 349 }],
  },
  {
    name: "Kimchi Ramen",
    category: "Ramen",
    desc: "Tangy fermented kimchi broth with deep umami warmth and a gentle heat.",
    img: IMG.ramen,
    spice: 3,
    variants: [{ label: "Veg", price: 299 }, { label: "Chicken", price: 349 }],
  },
  {
    name: "Korean Curry Ramen",
    category: "Ramen",
    desc: "Mellow, aromatic Korean curry broth — cosy, mild and full of flavour.",
    img: IMG.ramen,
    spice: 2,
    variants: [{ label: "Veg", price: 299 }, { label: "Chicken", price: 349 }],
  },

  // ---------- NOODLE BOX ----------
  {
    name: "Gochujang Noodle Box",
    category: "Noodle Box",
    desc: "Wok-tossed noodles in a sweet-savoury gochujang glaze. Grab-and-go slurp joy.",
    img: IMG.noodle,
    spice: 1,
    variants: [{ label: "Veg", price: 239 }, { label: "Chicken", price: 249 }],
  },
  {
    name: "Mongolian Noodle Box",
    category: "Noodle Box",
    desc: "Smoky, garlicky Mongolian-style noodles with a bold, saucy finish.",
    img: IMG.noodle,
    spice: 2,
    variants: [{ label: "Veg", price: 239 }, { label: "Chicken", price: 249 }],
  },
  {
    name: "Bulgogi Noodle Box",
    category: "Noodle Box",
    desc: "Our most-ordered box — bulgogi-marinated noodles, glossy and irresistible.",
    img: IMG.noodle,
    spice: 3,
    variants: [{ label: "Veg", price: 239 }, { label: "Chicken", price: 249 }],
    signature: true,
    tag: "Bestseller",
  },

  // ---------- FRIED RICE (BOKKEUM-BAP) ----------
  {
    name: "Bokkeum-bap",
    category: "Fried Rice",
    desc: "Wok-kissed Korean fried rice — smoky, savoury and deeply satisfying.",
    img: IMG.friedRice,
    variants: [{ label: "Veg", price: 259 }, { label: "Egg", price: 279 }, { label: "Chicken", price: 299 }],
  },
  {
    name: "Crispy Bokkeum-bap",
    category: "Fried Rice",
    desc: "Crisp-bottomed fried rice with irresistible golden, crackly edges.",
    img: IMG.friedRice,
    variants: [{ label: "Veg", price: 259 }, { label: "Egg", price: 279 }, { label: "Chicken", price: 299 }],
  },
  {
    name: "Katsu Bokkeum-bap",
    category: "Fried Rice",
    desc: "Fried rice crowned with a crunchy panko chicken katsu cutlet.",
    img: IMG.friedRice,
    variants: [{ label: "Chicken", price: 329 }],
  },

  // ---------- TTEOK-BOKKI ----------
  {
    name: "Tteok-bokki",
    category: "Tteok-bokki",
    desc: "Chewy Korean rice cakes simmered in a sweet-spicy gochujang sauce. The ultimate street snack.",
    img: IMG.ramen,
    spice: 4,
    variants: [{ label: "Veg", price: 259 }, { label: "Chicken", price: 279 }, { label: "Fish Cake", price: 299 }],
    tag: "Street Classic",
  },

  // ---------- BAO BUNS ----------
  {
    name: "Korean Chicken Bao",
    category: "Bao Buns",
    desc: "Cloud-soft steamed buns hugging saucy Korean fried chicken and fresh crunch.",
    img: IMG.bao,
    serves: "2 pcs",
    spice: 2,
    variants: [{ label: "", price: 269 }],
    signature: true,
    tag: "Signature",
  },
  {
    name: "Devil Bao",
    category: "Bao Buns",
    desc: "For heat-seekers — fiery chicken tucked into pillowy bao. Handle with napkins.",
    img: IMG.bao,
    serves: "2 pcs",
    spice: 5,
    variants: [{ label: "", price: 269 }],
    tag: "Fiery",
  },
  {
    name: "Teriyaki Bao",
    category: "Bao Buns",
    desc: "Glossy teriyaki filling in soft steamed buns. Sweet, savoury, satisfying. Veg or non-veg.",
    img: IMG.bao,
    serves: "2 pcs",
    spice: 1,
    variants: [{ label: "", price: 269 }],
  },
  {
    name: "Tempura Bao",
    category: "Bao Buns",
    desc: "Crispy tempura fish or prawn in a fluffy bun with a zingy sauce.",
    img: IMG.bao,
    serves: "2 pcs",
    spice: 2,
    variants: [{ label: "", price: 289 }],
  },

  // ---------- STEAMED DUMPLINGS ----------
  {
    name: "Classic Dumplings",
    category: "Dumplings",
    desc: "Pillowy steamed mandu packed with juicy, well-seasoned filling. Veg or non-veg.",
    img: IMG.dumpling,
    serves: "6 pcs",
    variants: [{ label: "", price: 229 }],
  },
  {
    name: "Kung Pao Dumplings",
    category: "Dumplings",
    desc: "Steamed dumplings tossed in a bold, tangy kung pao sauce.",
    img: IMG.dumpling,
    serves: "6 pcs",
    spice: 3,
    variants: [{ label: "", price: 259 }],
  },
  {
    name: "Cheese Dumplings",
    category: "Dumplings",
    desc: "Molten cheese-filled dumplings with an irresistible gooey pull.",
    img: IMG.dumpling,
    serves: "6 pcs",
    variants: [{ label: "", price: 259 }],
    signature: true,
  },

  // ---------- KOREAN FRIED CHICKEN (K-DRAMA) ----------
  {
    name: "K-Pops",
    category: "Korean Fried Chicken",
    desc: "Poppable double-fried bites glazed in your choice of signature Korean flavours. Chicken or paneer.",
    img: IMG.wings,
    variants: [{ label: "Regular · 6 pc", price: 249 }, { label: "Large · 10 pc", price: 259 }],
    note: "Choose a flavour",
    signature: true,
    tag: "Bestseller",
  },
  {
    name: "K-Dumplings",
    category: "Korean Fried Chicken",
    desc: "Crispy-fried dumplings, golden and crunchy with a savoury centre.",
    img: IMG.dumpling,
    variants: [{ label: "Regular · 6 pc", price: 299 }, { label: "Large · 8 pc", price: 349 }],
  },
  {
    name: "K-Wings / Cauliflower",
    category: "Korean Fried Chicken",
    desc: "Double-fried crackle glazed in gochujang or soy-garlic. The crunch you'll dream about — chicken or cauliflower.",
    img: IMG.wings,
    variants: [{ label: "Mini · 4 pc", price: 229 }, { label: "Regular · 6 pc", price: 329 }, { label: "Large · 10 pc", price: 499 }],
    note: "Choose a flavour",
    signature: true,
    tag: "Crowd Fave",
  },

  // ---------- CORN DOGS ----------
  {
    name: "Cheesy Corn Dog",
    category: "Corn Dogs",
    desc: "Stretchy cheese-pull corn dog rolled in crispy gold. Pure Seoul street joy.",
    img: IMG.corndog,
    variants: [{ label: "Veg", price: 229 }],
    tag: "Fun",
  },
  {
    name: "Half n Half Corn Dog",
    category: "Corn Dogs",
    desc: "Half sausage, half cheese — the best of both in one crispy bite.",
    img: IMG.corndog,
    variants: [{ label: "Non-Veg", price: 249 }],
    tag: "Fun",
  },
  {
    name: "Sausage Corn Dog",
    category: "Corn Dogs",
    desc: "Juicy sausage in a crunchy golden coat. A classic done right.",
    img: IMG.corndog,
    variants: [{ label: "Non-Veg", price: 229 }],
  },

  // ---------- KARAAGE FRIES ----------
  {
    name: "Classic Karaage Fries",
    category: "Karaage Fries",
    desc: "Loaded fries dusted in Korean spice — unapologetically snackable.",
    img: IMG.fries,
    variants: [{ label: "", price: 229 }],
  },
  {
    name: "Paneer Karaage Fries",
    category: "Karaage Fries",
    desc: "Crispy fries topped with golden karaage paneer and signature sauce.",
    img: IMG.fries,
    variants: [{ label: "", price: 249 }],
  },
  {
    name: "Chicken Karaage Fries",
    category: "Karaage Fries",
    desc: "Fries piled with crunchy Japanese-Korean fried chicken. Irresistible.",
    img: IMG.fries,
    variants: [{ label: "", price: 249 }],
  },

  // ---------- BEVERAGES ----------
  {
    name: "Matcha",
    category: "Beverages",
    desc: "Stone-ground matcha, smooth and grassy — with or without a cream-cheese crown.",
    img: IMG.matcha,
    variants: [{ label: "Original", price: 239 }, { label: "Cream Cheese", price: 259 }],
    signature: true,
  },
  {
    name: "Taro",
    category: "Beverages",
    desc: "Silky taro milk with a dreamy lilac hue — the drink everyone photographs.",
    img: IMG.taro,
    variants: [{ label: "Original", price: 239 }, { label: "Cream Cheese", price: 259 }],
    tag: "Insta Fave",
  },
  {
    name: "Thai Milk",
    category: "Beverages",
    desc: "Rich, aromatic Thai milk tea — sweet, creamy and refreshing.",
    img: IMG.taro,
    variants: [{ label: "Original", price: 239 }, { label: "Cream Cheese", price: 259 }],
  },
  {
    name: "Koko Cooler",
    category: "Beverages",
    desc: "Refreshing fruity coolers — litchi, mango or strawberry. Tropical and thirst-quenching.",
    img: IMG.koko,
    variants: [{ label: "Litchi / Mango / Strawberry", price: 189 }],
  },

  // ---------- DESSERTS ----------
  {
    name: "Choco Bao",
    category: "Desserts",
    desc: "Warm dessert bao oozing molten chocolate. A sweet finish, Seoul style.",
    img: IMG.chocoBao,
    serves: "3 pcs",
    variants: [{ label: "", price: 219 }],
    tag: "Dessert",
  },
];

export const TESTIMONIALS = [
  {
    name: "Abhisek Patnaik",
    location: "Sarjapura",
    text: "Visited Koreyaah with friends and loved the food! Tried Dumpling Soup Ramen, K-Wings and Hot & Spicy Ramen — all delicious and full of authentic Korean flavours. Great ambiance and friendly staff!",
    rating: 5,
  },
  {
    name: "Swati Hans",
    location: "Sarjapura",
    text: "Awesome ramen. Buldak rabokki was extremely spicy but very tasty. Must try place!",
    rating: 5,
  },
  {
    name: "Taraprasad Rout",
    location: "Sarjapura",
    text: "Bulgogi noodles — one of the best noodles ever tried. Cheese corndog is a must. The ambience is superb. Best Korean food in Bangalore.",
    rating: 5,
  },
  {
    name: "Santwana H",
    location: "Sarjapura",
    text: "Never expected veg to be this good. The best place — neat, clean, and the staff explained how they make everything.",
    rating: 5,
  },
  {
    name: "saurabh anand",
    location: "Begur",
    text: "One of the best places for ramen and noodles. Truly authentic taste. My entire family loves it.",
    rating: 5,
  },
  {
    name: "SivaShankar Behera",
    location: "Begur",
    text: "Tried the Bulgogi Mongolian mix — liked the taste with moderate spice and good quantity. Will definitely visit again to explore more Korean flavours!",
    rating: 5,
  },
  {
    name: "Sushant Kulal",
    location: "Begur",
    text: "Amazing food, highly recommended. Hot n Spicy Ramen and K-Pops chicken are a must try.",
    rating: 5,
  },
  {
    name: "Amogh Kasture",
    location: "Sarjapura",
    text: "The flavour profile is exceptional. I appreciate both the ambiance and the culinary presentation.",
    rating: 5,
  },
];

// Per-outlet Google review summary. `url` opens the outlet's Google listing where
// all reviews are shown. Update rating/count with live values when available.
export const REVIEW_LOCATIONS = [
  { key: "Sarjapura", label: "Sarjapura", rating: 4.7, count: null, url: STORES[0].directions },
  { key: "Begur", label: "Begur", rating: 4.9, count: null, url: STORES[1].directions },
];

export const MANIFESTO = [
  {
    no: "01",
    title: "Spice, Rice & Everything Nice",
    text: "We chase the electric buzz of Seoul's night markets — bold gochujang heat, comforting broths, and that first cheese-pull gasp. Every plate is built to make you say 'you've got to try this!'",
  },
  {
    no: "02",
    title: "Korean Heart, Indian Warmth",
    text: "Authentic Korean classics, served with the hospitality Bangalore knows best. A space where K-food fans and first-timers feel right at home.",
  },
  {
    no: "03",
    title: "Fast, Fresh, Unforgettable",
    text: "Street-food energy with modern charm. Made quick, made fresh, made to be your daily dose of Seoul.",
  },
];

export const WHY = [
  { title: "Authentic Recipes", desc: "Real Korean flavours, no shortcuts — gochujang, sesame, and double-fried crunch done right." },
  { title: "Fresh & Fast", desc: "QSR speed without compromise. Hot, fresh and flavour-packed, every single time." },
  { title: "Vibrant Vibes", desc: "A bold, playful space designed for good food and good company." },
  { title: "Veg & Non-Veg", desc: "A full spread for everyone — nobody misses out on the fun." },
];

export const FRANCHISE_ADVANTAGES = [
  { title: "Proven QSR Model", desc: "A streamlined kitchen and tight menu engineered for high throughput and strong margins." },
  { title: "Booming Category", desc: "Korean food is India's fastest-rising cuisine, powered by K-culture and Gen-Z demand." },
  { title: "Compact Footprint", desc: "Efficient store formats that work in malls, high-streets and food courts." },
  { title: "Brand That Pops", desc: "A distinctive, Instagrammable identity that turns customers into fans." },
  { title: "End-to-End Support", desc: "Site selection, kitchen setup, training, supply chain and marketing playbooks." },
  { title: "Central Sourcing", desc: "Consistent taste through centralised recipes, sauces and quality control." },
];

export const INVESTMENT = [
  { label: "Investment Range", value: "₹25–45 L*" },
  { label: "Area Required", value: "300–800 sq.ft" },
  { label: "Break-even", value: "12–18 months*" },
  { label: "Franchise Term", value: "5 Years" },
];

export const FRANCHISE_FAQ = [
  { q: "What is the total investment required?", a: "Depending on the format and city, the typical investment ranges from ₹25–45 lakhs, covering interiors, kitchen equipment, branding and initial working capital. Figures are indicative and confirmed after evaluation." },
  { q: "Do I need prior F&B experience?", a: "No — while F&B experience helps, our training and operational playbooks are designed to onboard first-time restaurateurs. Passion and commitment matter most." },
  { q: "What support does Koreyaah provide?", a: "We assist with site selection, store design, kitchen setup, staff training, central supply of key ingredients, and ongoing marketing support." },
  { q: "How long until my outlet opens?", a: "Once the site is finalised and agreements are signed, a typical outlet is operational within 60–90 days." },
  { q: "Which cities are you expanding to?", a: "We're actively expanding across Bangalore and key metros. Share your preferred location in the form and our team will get in touch." },
];
